module.exports = __webpack_public_path__ + "img/enterprise-plan-icon.c20f437.svg";